import React, { useState, useEffect } from 'react'
import FormSubmissionHandler from '../../../UIComponents/FormSubmissionHandler';
// import SelectBoxHandler from '../../../UIComponents/SelectBoxHandler';
// import CheckBoxHandler from '../../../UIComponents/CheckBoxHandler';
// import CustomImage from '../../../UIComponents/CustomImage';
// import CustomLink from '../../../UIComponents/CustomLink';
import FileUploadHandler from '../../../UIComponents/FileUploadHandler';
import NormalTextareaHandler from '../../../UIComponents/NormalTextareaHandler';
// import RadioButtonHandler from '../../../UIComponents/RadioButtonHandler';
// import TextareaHandler from '../../../UIComponents/TextareaHandler';
import InputHandler from '../../../UIComponents/InputHandler';
import Loader from '../../../UIComponents/Loader';
import { postAPI, postAPIForm, getURL, formatDate, convertTo12Hour, splitISODateTime } from '../../../app/api';
import { store } from '../../../app/store';
import { hasPermission, isAdmin } from '../../../store/hooks/Permission';
import { ToastContainer, toast, Slide, Zoom, Flip, Bounce } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import './tooltip.css';
import Excel from '../../../components/Excel/Excel';
import { DownloadOutlined } from '@ant-design/icons';

export default function List({ PopupID = "", setIsEdit, setEditId, setIsReschedule }) {
    const store_data = JSON.parse(store());
    const [IsBTNClicked, setIsBTNClicked] = useState(false);
    const [ExamData, setExamData] = useState([]);
    const [Loading, setLoading] = useState(true);

    // Permission states
    const [canView, setCanView] = useState(false);
    const [canEdit, setCanEdit] = useState(false);
    const [canDelete, setCanDelete] = useState(false);
    const [canToggleStatus, setCanToggleStatus] = useState(false);
    const [canManageRewards, setCanManageRewards] = useState(false);
    const [canManageParticipants, setCanManageParticipants] = useState(false);
    const [canManageQuestions, setCanManageQuestions] = useState(false);
    const [canExport, setCanExport] = useState(false);

    useEffect(() => {
        // Check permissions first
        const checkPermissions = async () => {
            if (isAdmin()) {
                setCanView(true);
                setCanEdit(true);
                setCanDelete(true);
                setCanToggleStatus(true);
                setCanManageRewards(true);
                setCanManageParticipants(true);
                setCanManageQuestions(true);
                setCanExport(true);
                fetchExamData();
            } else {
                const viewAllowed = await hasPermission("EXAM", "AdminExams", "VIEW");
                const editAllowed = await hasPermission("EXAM", "AdminExams", "EDIT");
                const deleteAllowed = await hasPermission("EXAM", "AdminExams", "DELETE");
                const toggleAllowed = await hasPermission("EXAM", "AdminExams", "TOGGLESTATUS");
                const exportAllowed = await hasPermission("EXAM", "AdminExams", "EXPORT");

                const rewardsSetupAllowed = await hasPermission("REWARDS", "RewardSetup", "VIEW");
                const participantsAllowed = await hasPermission("EXAM", "Participants", "VIEW");
                // const participantsAllowed = await hasPermission("EXAM", "Enrollments", "VIEW");
                const questionsAllowed = await hasPermission("EXAM", "Questions", "VIEW");
                const rewardsAllotmentAllowed = await hasPermission("REWARDS", "RewardAllotment", "VIEW");


                setCanView(viewAllowed);
                setCanEdit(editAllowed);
                setCanDelete(deleteAllowed);
                setCanToggleStatus(toggleAllowed);
                setCanExport(exportAllowed);
                setCanManageRewards(rewardsSetupAllowed || rewardsAllotmentAllowed);
                setCanManageParticipants(participantsAllowed);
                setCanManageQuestions(questionsAllowed);

                if (viewAllowed) {
                    fetchExamData();
                } else {
                    setExamData([]);
                    setLoading(false);
                    toast.error('You do not have permission to view this page.');
                }
            }
        };

        checkPermissions();
        // eslint-disable-next-line
    }, []);

    const fetchExamData = async () => {
        const filter = { id: store_data?.org_id }
        const response = await postAPI("/exams/list", filter);
        if (response?.status) {
            setExamData(response?.data)
            setLoading(false)
        } else {
            setExamData([])
            setLoading(false)
        }
    }

    const handleChangeStatus = async (id, status) => {
        if (!canToggleStatus) {
            toast.error('You do not have permission to perform this action');
            return;
        }
        const filter = { org_id: store_data?.org_id, id: id, status: status }
        const response = await postAPI("/exams/toggle-status", filter);
        if (response?.status == 1) {
            toast.success('Status changed successfully.');
            window.location.reload()
        } else {
            toast.error('Sorry ! Something Wrong. Please try to contact administrator.');
        }
    }

    const handleRemove = async id => {
        if (!canDelete) {
            toast.error('You do not have permission to perform this action');
            return;
        }
        const filter = { org_id: store_data?.org_id, id: id }
        const response = await postAPI("/exams/remove", filter);
        if (response?.status == 1) {
            toast.success('Exam removed successfully.');
            window.location.reload()
        } else {
            toast.error('Sorry ! Something Wrong. Please try to contact administrator.');
        }
    }

    useEffect(() => {
        fetchExamData();
    }, [])

    const getExamState = (val) => {
        const now = new Date();
        const dateStr = val?.exam_date ? val.exam_date.split('T')[0] : '';
        if (!dateStr) return 'before';
        const startDT = new Date(`${dateStr}T${val?.exam_start_time || '00:00:00'}`);
        const endDT = new Date(`${dateStr}T${val?.exam_end_time || '23:59:59'}`);
        if (now < startDT) return 'before';
        if (now >= startDT && now <= endDT) return 'running';
        return 'ended';
    };


    const archieveExam = async (exam) => {
        if (!canDelete) {
            toast.error('You do not have permission to perform this action');
            return;
        }
        const payload = { org_id: store_data?.org_id, id: exam?.id }
        const response = await postAPI("/exams/archieve", payload);
        if (response?.status == 1) {
            toast.success('Exam archieved successfully.');
            window.location.reload()
        } else {
            toast.error('Sorry ! Something Wrong. Please try to contact administrator.');
        }
    }


    return (
        <>
            <div className="container-fluid mb-3 gap-2 p-0 d-flex justify-content-end">
                <button className="btn btn-primary btn-sm" disabled={!canExport}>
                    <Excel
                        data={{ Name: "Exams", Data: ExamData }}
                        filename="exams-export.xlsx"
                    >
                        <DownloadOutlined /> Export
                    </Excel>
                </button>
            </div>
            <table className="table card-table">
                <thead>
                    <tr>
                        {/* <th>Date</th> */}
                        <th>Exam Details</th>
                        <th>Portal Avalilibility</th>
                        <th>Enrollment & Resource</th>
                        {/* <th>Start Time</th> */}
                        {/* <th>End Time</th> */}
                        {/* <th>Public Access Link</th> */}
                        <th>Status</th>
                        <th style={{ maxWidth: '210px' }}>Actions</th>
                    </tr>
                </thead>
                <tbody className="table-border-bottom-0">
                    {!canView ? (
                        <tr>
                            <td colSpan="5" className="text-center text-danger py-4">
                                You do not have permission to view this page.
                            </td>
                        </tr>
                    ) : ExamData && ExamData?.length > 0 ?
                        ExamData?.map((val, index) => (
                            <tr key={index + 1}>
                                {/* <td>
                                        {formatDate(val?.exam_date)?.month} {formatDate(val?.exam_date)?.day}, {formatDate(val?.exam_date)?.year}
                                    </td>
                                    <td>{val?.exam_title}</td>
                                    <td>{val?.pre_question_time_in_sec}</td>
                                    <td>{val?.exam_start_time}</td>
                                    <td>{val?.exam_end_time}</td> */}
                                {/* <td><a href={`/Exams/${val?.public_access_token_salt}/${store_data?.org_id}/${store_data?.user_unique_id}/Live`} target='_blank'><button type='button' className='btn btn-secondary create-new btn-primary'>Visit</button></a></td> */}
                                <td>
                                    <p>{val?.exam_title}</p>
                                    <p>Exam Date: {formatDate(val?.exam_date)?.month} {formatDate(val?.exam_date)?.day}, {formatDate(val?.exam_date)?.year}</p>
                                    <p>Time: {convertTo12Hour(val?.exam_start_time)} - {convertTo12Hour(val?.exam_end_time)}</p>
                                </td>
                                <td>
                                    <p>Opening: {formatDate((splitISODateTime(val?.portal_start_datetime)[0]))?.month} {formatDate((splitISODateTime(val?.portal_start_datetime)[0]))?.day}, {formatDate((splitISODateTime(val?.portal_start_datetime)[0]))?.year} {convertTo12Hour((splitISODateTime(val?.portal_start_datetime)[1]))}</p>
                                    <p>Closing: {formatDate(splitISODateTime(val?.portal_end_datetime)[0])?.month} {formatDate(splitISODateTime(val?.portal_end_datetime)[0])?.day}, {formatDate(splitISODateTime(val?.portal_end_datetime)[0])?.year} {convertTo12Hour(splitISODateTime(val?.portal_end_datetime)[1])}</p>
                                </td>
                                <td>
                                    <p>Enroll Start: {formatDate(val?.enroll_start_date)?.month} {formatDate(val?.enroll_start_date)?.day}, {formatDate(val?.enroll_start_date)?.year} {convertTo12Hour(val?.enroll_start_time)}</p>
                                    <p>Enroll End: {formatDate(val?.enroll_end_date)?.month} {formatDate(val?.enroll_end_date)?.day}, {formatDate(val?.enroll_end_date)?.year} {convertTo12Hour(val?.enroll_end_time)}</p>
                                    {/* <p>Resource Availibility: {formatDate(splitISODateTime(val?.portal_end_datetime)[0])?.month} {formatDate(splitISODateTime(val?.portal_end_datetime)[0])?.day}, {formatDate(splitISODateTime(val?.portal_end_datetime)[0])?.year} {convertTo12Hour(splitISODateTime(val?.portal_end_datetime)[1])}</p> */}
                                </td>

                                <td>
                                    <span className="tooltip">
                                        <span className={`badge ${val?.status === 1 ? 'bg-label-success' : 'bg-label-secondary'} me-1 cursor-pointer`} onClick={() => handleChangeStatus(val?.id, !val?.status)}>{val?.status === 1 ? 'Active' : 'Inactive'}</span>
                                        <span className="tooltiptext">Change Status</span>
                                    </span>
                                </td>
                                <td style={{ maxWidth: '210px' }}>


                                    {
                                        val?.is_archived == 1 ? (
                                            <>
                                                <span className="tooltip">
                                                    <span className={`badge bg-label-secondary me-1 mt-1`}><i className="fa fa-archive"></i></span>
                                                    <span className="tooltiptext">Archived</span>
                                                </span>
                                            </>
                                        ) : val?.is_result_published == 1 ? (
                                            <>
                                                <span className="tooltip">
                                                    <span className={`badge bg-label-secondary me-1 mt-1`}><i className="fa fa-check"></i></span>
                                                    <span className="tooltiptext">Result Published</span>
                                                </span>
                                                <span className="tooltip">
                                                    <span className={`badge bg-label-success me-1 mt-1`} onClick={() => archieveExam(val)}><i className="fa fa-archive"></i></span>
                                                    <span className="tooltiptext">Archive Exam</span>
                                                </span>
                                            </>
                                        ) : <>
                                            {/* Before exam: Reward Setup, Questions, Edit, Delete, Enrollments */}
                                            {getExamState(val) === 'before' && canManageRewards && (
                                                <span className="tooltip">
                                                    <span className="badge bg-label-primary me-1 mt-1" onClick={() => window.location.href = `/Admin/Setting/Exam/${val?.id}/RewardSetup`}><i className="fa fa-trophy"></i></span>
                                                    <span className="tooltiptext">Reward Setup</span>
                                                </span>
                                            )}
                                            {/* After exam: Participants */}
                                            {getExamState(val) === 'ended' && canManageParticipants && (
                                                <span className="tooltip">
                                                    <span className="badge bg-label-primary me-1 mt-1" onClick={() => window.location.href = `/Admin/Setting/Exam/${val?.id}/Participants`}><i className="fa fa-users"></i></span>
                                                    <span className="tooltiptext">Participants</span>
                                                </span>
                                            )}
                                            {/* Always visible: Enrollments */}
                                            <span className="tooltip">
                                                <span className="badge bg-label-primary me-1 mt-1" onClick={() => window.location.href = `/Admin/Setting/Exam/${val?.id}/Enrollments`}><i class="fa fa-address-book"></i></span>
                                                <span className="tooltiptext">Enrollment lists</span>
                                            </span>
                                            {/* Before exam: Questions */}
                                            {getExamState(val) === 'before' && canManageQuestions && (
                                                <span className="tooltip">
                                                    <span className="badge bg-label-primary me-1 mt-1" onClick={() => window.location.href = `/Admin/Setting/Exam/${val?.id}/Questions`}><i className="fa fa-building rotate-180"></i></span>
                                                    <span className="tooltiptext">Questions</span>
                                                </span>
                                            )}
                                            {/* After exam: Reward Allotment */}
                                            {getExamState(val) === 'ended' && canManageRewards && (
                                                <span className="tooltip">
                                                    <span className="badge bg-label-primary me-1 mt-1" onClick={() => window.location.href = `/Admin/Setting/Exam/${val?.id}/RewardAllotment`}><i className="fa fa-inr"></i></span>
                                                    <span className="tooltiptext">Reward Allotment</span>
                                                </span>
                                            )}
                                            {/* Before exam: Edit */}
                                            {(getExamState(val) === 'before' && canEdit) ?
                                                <span className="tooltip">
                                                    <span className="badge bg-label-primary me-1 mt-1" onClick={() => { setIsEdit(true); setEditId(val?.id); }} data-bs-toggle="modal" data-bs-target={`#${PopupID}`}><i className="fa fa-pen"></i></span>
                                                    <span className="tooltiptext">Edit Exam</span>
                                                </span>
                                                :
                                                <span className="tooltip">
                                                    <span className="badge bg-label-primary me-1 mt-1" onClick={() => { setIsEdit(true); setEditId(val?.id); setIsReschedule(true); }} data-bs-toggle="modal" data-bs-target={`#${PopupID}`}><i className="fa fa-calendar"></i></span>
                                                    <span className="tooltiptext">Reschedule Exam</span>
                                                </span>
                                            }
                                            {/* Before exam: Delete */}
                                            {getExamState(val) === 'before' && canDelete && (
                                                <span className="tooltip">
                                                    <span className="badge bg-label-danger me-1 mt-1 cursor-pointer"
                                                        onClick={() => {
                                                            if (window.confirm("Are you sure? This action will permanently remove this data!")) {
                                                                handleRemove(val?.id);
                                                            } else {
                                                                console.log("Remove cancelled.");
                                                            }
                                                        }}
                                                    ><i className="fa fa-trash"></i></span>
                                                    <span className="tooltiptext">Delete Exam</span>
                                                </span>
                                            )}
                                        </>}
                                </td>
                            </tr>
                        ))
                        : ''
                    }
                </tbody>
            </table>
        </>
    )
}
